import React from 'react';

import ItemDetail from '~/components/Details/ItemDetail';
import { IUserProfile } from '~/store/modules/users/types';

import { Items } from './styles';

interface AddressItemsProps {
  userProfile: IUserProfile;
}

const AddressItems = ({ userProfile }: AddressItemsProps) => {
  return (
    <Items>
      <ItemDetail
        className={
          userProfile?.dynamicAttributes?.zipCode === '' ||
          userProfile.dynamicAttributes === null
            ? 'undefinedItem'
            : ''
        }
        label="Cep"
        value={
          userProfile?.dynamicAttributes?.zipCode === '' ||
          userProfile.dynamicAttributes === null
            ? 'Não informado'
            : userProfile?.dynamicAttributes?.zipCode?.replace(
                /^(\d{5})(\d)/,
                '$1-$2',
              )
        }
      />
      <ItemDetail
        className={
          userProfile?.dynamicAttributes?.street === '' ||
          userProfile.dynamicAttributes === null
            ? 'undefinedItem'
            : ''
        }
        label="Logradouro"
        value={
          userProfile?.dynamicAttributes?.street === '' ||
          userProfile.dynamicAttributes === null
            ? 'Não informado'
            : userProfile?.dynamicAttributes?.street
        }
      />
      <ItemDetail
        className={
          userProfile?.dynamicAttributes?.number === '' ||
          userProfile.dynamicAttributes === null
            ? 'undefinedItem'
            : ''
        }
        label="Número"
        value={
          userProfile?.dynamicAttributes?.number === '' ||
          userProfile.dynamicAttributes === null
            ? 'Não informado'
            : userProfile?.dynamicAttributes?.number
        }
      />
      <ItemDetail
        className={
          userProfile?.dynamicAttributes?.district === '' ||
          userProfile.dynamicAttributes === null
            ? 'undefinedItem'
            : ''
        }
        label="Bairro"
        value={
          userProfile?.dynamicAttributes?.district === '' ||
          userProfile.dynamicAttributes === null
            ? 'Não informado'
            : userProfile?.dynamicAttributes?.district
        }
      />
      <ItemDetail
        className={
          userProfile?.dynamicAttributes?.city === '' ||
          userProfile.dynamicAttributes === null
            ? 'undefinedItem'
            : ''
        }
        label="Cidade"
        value={
          userProfile?.dynamicAttributes?.city === '' ||
          userProfile.dynamicAttributes === null
            ? 'Não informado'
            : userProfile?.dynamicAttributes?.city
        }
      />
      <ItemDetail
        className={
          userProfile?.dynamicAttributes?.city === '' ||
          userProfile.dynamicAttributes === null
            ? 'undefinedItem'
            : ''
        }
        label="UF"
        value={
          userProfile?.dynamicAttributes?.city === '' ||
          userProfile.dynamicAttributes === null
            ? 'Não informado'
            : userProfile?.dynamicAttributes?.city
        }
      />
    </Items>
  );
};

export default AddressItems;
